import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
})
export class AuthCallbackComponent implements OnInit {

  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
  ) {}

  ngOnInit(): void {
    const code  = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');

    const isPopup  = !!(window.opener && window.opener !== window);
    const isIframe = !isPopup && window.parent !== window;

    if (isPopup || isIframe) {
      // Running inside a popup or a hidden silent-auth iframe: relay code+state
      // to the parent window/frame and stop. The parent (which retains the PKCE
      // verifier in sessionStorage) handles the token exchange.
      const target = isPopup ? window.opener : window.parent;
      const errMsg = error || (!code || !state ? 'missing_params' : null);
      target.postMessage(
        { type: 'AUTH0_CODE', code, state, error: errMsg },
        window.location.origin
      );
      if (isPopup) window.close();
      return;
    }

    // `login_required` es la respuesta normal del SSO por redirect cuando no hay
    // sesión en Auth0: el usuario no hizo nada mal, así que se lo manda al login
    // sin mensaje de error. La marca de intento (ya puesta antes de navegar)
    // evita que se vuelva a disparar el SSO y se arme un bucle.
    if (error === 'login_required') {
      this.router.navigate(['/login']);
      return;
    }

    // Direct navigation (fallback redirect flow or external link)
    if (error || !code || !state) {
      this.error = error || 'missing_params';
      this.router.navigate(['/login'], { queryParams: { error: this.error } });
      return;
    }

    this.loginService.handleAuth0Callback(code, state).subscribe({
      next: () => {
        this.loginService.clearSilentAuthAttempt();
        let backToUrl = this.loginService.getRedirectUrl();
        if (backToUrl === '/login') backToUrl = undefined;
        this.loginService.clearRedirectUrl();
        this.router.navigateByUrl(backToUrl ?? '/');
      },
      error: err => {
        this.error = err?.message || 'auth_failed';
        this.router.navigate(['/login'], { queryParams: { error: this.error } });
      },
    });
  }
}
